import { render, staticRenderFns } from "./InscriptionExtranet.vue?vue&type=template&id=28002cb4&scoped=true"
import script from "./InscriptionExtranet.vue?vue&type=script&lang=js"
export * from "./InscriptionExtranet.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=28002cb4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28002cb4",
  null
  
)

export default component.exports